import { render, staticRenderFns } from "./ModalPreviewHistory.vue?vue&type=template&id=3a0ab61e&scoped=true"
import script from "./ModalPreviewHistory.vue?vue&type=script&lang=js"
export * from "./ModalPreviewHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0ab61e",
  null
  
)

export default component.exports